<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Información para Proforma"
          directory="Datos a Generar"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="returnPage()"
          >
            Regresar
          </button>
        </div>
      </div>
    </div>

    <form
      ref="form"
      data-url="/org/proformadata/storeProforma"
      class="mb-0"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="form-group">
            <label>Razón Social</label>
            <app-input
              type="text"
              v-model="inputs.org.name"
              placeholder="Ingrese la Razón Social"
              :required="true"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Nombre Comercial</label>
            <app-input
              type="text"
              v-model="inputs.org.business_name"
              :required="true"
              placeholder="Ingrese el Nombre Comercial"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de Identificación</label>
            <app-input
              type="select"
              v-model="inputs.org.taxid_type"
              v-on:change="
                onChangeTaxid('orgTaxid', inputs.org.taxid_type, inputs.org.taxid)
              "
              :required="true"
              :list="taxidTypeLists"
            />
          </div>
        </div>
        <div class="col-md-6" v-if="inputs.org.taxid_type == 'ruc'">
          <div class="form-group">
            <label>RUC</label>
            <app-input
              type="text"
              v-model="inputs.org.taxid"
              placeholder="Ingrese el RUC"
              :required="true"
              @keyup="
                () => {
                  inputs.org.taxid = inputs.org.taxid.replace(/[^0-9]/g, '');
                  onChangeTaxid(
                    'orgTaxid',
                    inputs.org.taxid_type,
                    inputs.org.taxid
                  );
                }
              "
            />
          </div>
        </div>
        <div class="col-md-6" v-if="inputs.org.taxid_type == 'other'">
          <div class="form-group">
            <label>RUT, NIT, Etc.</label>
            <app-input
              type="text"
              v-model="inputs.org.taxid"
              placeholder="Ingrese el RUT, NIT, Etc."
              :required="true"
              @keyup="
                () => {
                  onChangeTaxid(
                    'orgTaxid',
                    inputs.org.taxid_type,
                    inputs.org.taxid
                  );
                }
              "
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Representante Legal</label>
            <app-input
              type="text"
              v-model="inputs.org.legal_representative"
              :required="true"
              placeholder="Ingrese el Representante Legal"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>País</label>
            <app-input
              type="select"
              v-model="inputs.org.country_id"
              :list="[
                { id: '', value: 'Seleccione una opción' },
                ...this.$store.state.common.countries,
              ]"
              :required="true"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          v-if="inputs.org.country_id && provinceList.length <= 1"
        >
          <div class="form-group">
            <label>Ciudad</label>
            <app-input
              type="text"
              v-model="inputs.org.city"
              placeholder="Ingrese la Ciudad"
              :required="true"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group">
            <label>Provincia</label>
            <app-input
              type="select"
              v-model="inputs.org.province_id"
              :list="[
                { id: '', value: 'Seleccione una opción' },
                ...provinceList,
              ]"
              :required="true"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group">
            <label>Ciudad</label>
            <app-input
              type="select"
              v-model="inputs.org.canton_id"
              :list="[{ id: '', value: 'Seleccione una opción' }, ...cantonList]"
              :required="true"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Teléfono</label>
            <app-input
              type="tel-input"
              v-model="inputs.org.phone"
              :required="true"
              placeholder="Ingrese el Teléfono"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail</label>
            <app-input
              type="email"
              v-model="inputs.org.email"
              placeholder="Ingrese su E-mail"
              :required="true"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Dirección</label>
            <app-input
              type="textarea"
              v-model="inputs.org.address"
              :required="true"
              placeholder="Ingrese la Dirección"
            />
          </div>
        </div>

      </div>
      <div class="row" >
          <div class="col-12 mt-3">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="submit"
            >
              {{ $t("save") }}
            </button>
          </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  props: {
    userId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        org: {},
      },
      provinceList: [],
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ruc", value: "Nacional" },
        { id: "other", value: "Internacional" },
      ],
    }
  },computed: {
    cantons() {
        return this.$store.getters.getCantons();
      }, 
  },
  watch: {
    "inputs.org.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
    },

    "inputs.org.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    selected: function () {
      if (!this.selected) {
        this.inputs.org = {};
      } else if (this.selected != this.inputs.orgs) {
        const tmp = this.orgs.filter((item) => item.id == this.selected);
        this.inputs.org = tmp[0];
      }
    },
  },
  created() {
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `/accreditations/process/evaluationTeam`;
    },
    data() {
      this.$store.dispatch("getPoliticalDivision");

      this.axiosGet(
        `/org/proformadata/showPF?userId=${this.userId}`
      )
        .then((response) => {
          this.preloader = true;
          if (response.status == 200 && response.data) {
            
            this.inputs.org = response.data;

          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      if(this.inputs.org.taxid_type == 'ruc' && (this.inputs.org.taxid.length != 13)) {
          this.$toastr.e("El RUC debe tener 13 digitos");
          return;
      }
      this.inputs.org.establishment_type = "PF";
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.preloader = false;
      this.returnPage();
      this.$toastr.s(this.$t("updated_success"));
    },
    onChangeTaxid(origin, type, taxid) {
      this[origin] = false;
      if (taxid && ["ci", "ruc"].includes(type)) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          if (type == "ruc" && taxid.length != 13) {
            this.$toastr.e("El RUC debe tener 13 digitos");
            return;
          }
          // this.validateTaxid(origin, type, taxid);
        }, 1000);
      } else {
        this[origin] = true;
      }
    },
  }

}
</script>

<style>

</style>